import React, {FC} from "react";
import GatewayService from "../../service/GatewayService";
import AppUtil, {getProfit, percent} from "../../util/AppUtil";
import {SGBMarket} from "../../models/SGBMarket";

type Props = {
    market: SGBMarket
    isComplex: boolean
}
//https://drive.google.com/file/d/17jWb6D4RsEgPHXJhveKujGPcywJ85iRY/view?usp=sharing


const SgbRowComponent: FC<Props> = (props: Props) => {
    let buy = (price: number) => {
        GatewayService.bidBuy(sgb.genInfo.tradingsymbol, sgb.genInfo.exchange, price+0.05)
    }

    let buyIOC = (price: number) => {
        GatewayService.buy(sgb.genInfo.tradingsymbol, sgb.genInfo.exchange, price+0.05)
    }

    let stepBack = () => {
        GatewayService.cancelOrders(sgb.genInfo.tradingsymbol, sgb.genInfo.exchange);
    }
    let sgb = props.market.sgb;
    let market = props.market;
    let bidType = market.maxBuyer > market.myBid?.price ? "red" : "green";
    let isComplex = props.isComplex;
    let shouldStepBackClass = market.myBid?.price > market.profitablePrice ? "red" : "green";
    return <tr>
        <td><a href={sgb.link} target="_blank">{sgb.genInfo.tradingsymbol}({market.holding})</a></td>
        <td className={"right"} onClick={() => console.log(market)}>{market.months}</td>
        <td className={"right"} onClick={() => console.log(market)}>{market.profitablePrice}({percent(market.goldPrice, market.profitablePrice)})</td>
        <td className="">
            <button onClick={() => buy(market.maxBuyer)}>{market.maxBuyer}</button>
            {getProfit(market, "bid")}
        </td>
        <td>{(market.bidYTM)}</td>
        <td>{(market.maxBuyer - market.profitablePrice).toFixed(1)}</td>
        <td className={bidType}>{market.myBid?.price ?? "no bid"}</td>
        {isComplex ? <td onClick={() => console.log(sgb)}>{sgb.tick.ohlc.low}({getProfit(market, "low")})</td> : <></>}
        {isComplex ? <td>{sgb.tick.volume_traded || "-"}</td> : <></>}
        {isComplex ? <td>{sgb.tick.average_traded_price || "-"}({getProfit(market, "avg")})</td> : <></>}
        {isComplex ? <td>{new Date(sgb.tick.last_trade_time!).toLocaleTimeString()}</td> : <></>}
        {isComplex ? <td>{sgb.tick.last_price!}</td> : <></>}
        {isComplex ?
            <td className={AppUtil.buyOpportunity(market) ? "green" : "red"}>{(Math.max(market.minSeller, sgb.circuits.lowerCircuit) - market.profitablePrice!).toFixed(1)}</td> : <></>}
        {/*{isComplex?<td className={sgb.buyOpportunity? "green" : "red"}>{sgb.sellerBid|| "-"}</td>:<></>}*/}
        {isComplex ? <td className={AppUtil.buyOpportunity(market) ? "green" : "red"}>
            <button
                onClick={() => buyIOC(market.minSeller)}>{market.minSeller === 0 ? "no seller" : market.minSeller}</button>
            {getProfit(market, "buy")}
        </td> : <></>}
        {isComplex ? <td>{market.buyYTM}</td> : <></>}
        {isComplex ? <td>{market.coupon.toFixed(2)}</td> : <></>}
        {isComplex ? <td>{market.daysForCoupon.toFixed(2)}</td> : <></>}
        <td>
            {
                market.myBid ? <button className={shouldStepBackClass} onClick={() => stepBack()}>STEP BACK force</button> : "----"
            }
        </td>
    </tr>
}
//TODO : check memo second param
export default React.memo(SgbRowComponent);
